<template>
	<div style="position: relative;">
		<div class="alert-light alert bg-light">
			<b-button
				@click="getSingleInheritedRates()"
				type="button"
				size="md"
				v-if="$hasPermission('rates.serviceType.show') && canHaveChildren"
				class="mr-1 mb-1 float-right"
				variant="success"
				content="Tarifas heredadas"
				v-tippy="{ arrow: true, arrowType: 'round' }"
			>
				<md-icon icon="manage_search" />
			</b-button>
			<b-table :items="items" :fields="columnsDetailRatePlan" table-class="table-sm">
				<template #cell(percentageDiscount)="row">
					{{row.item.percentageDiscount}}%
				</template>
				<template #cell(endDate)="">
					{{endDate}}
				</template>
				<template #cell(startDate)="row">
					{{formatDate(row.item.startDate)}}
				</template>
				<template #cell(supplierZonedArea.name)="row" >
					[{{row.item.supplierZonedArea.id}}] {{row.item.supplierZonedArea.name}}
				</template>
				<template #cell(zonedArea.name)="row" >
					[{{row.item.zonedArea.id}}] {{row.item.zonedArea.name}}
				</template>
			</b-table>

			<section v-if="this.heritance" class="container" table-class="table-sm">
				<h5>Heredando de :</h5>
				<b-table :items="[this.ratePlanModel.parentRatePlan]" :fields="columnsDetailRatePlanParent"></b-table>
			</section>
		</div>
		<hr>
		<b-overlay :show="loading" no-wrap />
		<div>

			<div>
				<b-form @submit.prevent="onSave">
					<b-row class="mb-1">
						<b-col cols="12">
							<map-zones-editing height="100" ref="rp-map-zones"/>
						</b-col>
					</b-row>
					<b-row class="container" v-if="ratePlanModel.id>0">
						<h3>[{{zonedAreaForPrice.id}}]{{zonedAreaForPrice.name}}:
							<a v-if="$hasPermission('zoneArea.show')"  class="btn btn-sm mr-1 btn-warning" target="_blank" :href="`/zoned-areas-edit?id=${zonedAreaForPrice.id}`"  >
								<md-icon icon="location_on" v-b-tooltip.hover title="Ir a la configuración de poligonos" />
							</a>
						</h3>
					</b-row>
					<b-row>
						<b-col cols="3">
							<b-card>
								<b-overlay :show="!editingPricesSaved" no-wrap >
									<template #overlay>SAVE YOUR CHANGES</template>
								</b-overlay>
								<h3>Seleccione origen</h3>
								<hr>
								<div
										class="mb-2"
										v-for="(zone,i) in zones"
										:key="i"
								>
									<b-input-group class="input-groups">
										<b-button  block @click="editingOriginZone = zone" class="zone-button" :variant="editingOriginZone == zone ? 'warning' : 'primary' ">
											<div v-if="zone.reason">
												<b-badge 
													variant="danger" 
													class="__shake" 
													v-b-tooltip.hover
													:title="zone.reason"
												>
													ERROR POLIGONO
												</b-badge>
											</div>
											{{zone.name}} 
											<md-icon v-if="editingOriginZone == zone" style="float:right" icon="arrow_forward_ios"/>
										</b-button>
									</b-input-group>

									<b-progress :max="averageZones['totalPerZone']" height="1rem" v-if="averageZones['totalPerZone']>0">
										<b-progress-bar variant="danger" :value="averageZones['totalPerZone']" animated v-if="!averageZonesFrom['z-'+zone.id]">
											<span><strong>0/{{averageZones['totalPerZone']}}</strong></span>
										</b-progress-bar>
										<b-progress-bar variant="success" :value="averageZonesFrom['z-'+zone.id]" animated v-else-if="(averageZonesFrom['z-'+zone.id] === averageZones['totalPerZone'])">
											<span><strong>{{averageZonesFrom['z-'+zone.id]}} / {{averageZones['totalPerZone']}}</strong></span>
										</b-progress-bar>
										<b-progress-bar  variant="info" :value="averageZonesFrom['z-'+zone.id]" animated v-else>
											<span><strong>{{averageZonesFrom['z-'+zone.id]}} / {{averageZones['totalPerZone']}}</strong></span>
										</b-progress-bar>
									</b-progress>
								</div>
							</b-card>
						</b-col>
						<b-col cols="3">
							<b-card>
								<b-overlay :show="!editingPricesSaved" no-wrap >
									<template #overlay>GUARDA TUS CAMBIOS</template>
								</b-overlay>
								<h3>Seleccione destino</h3>
								<hr>
								<div
										class="mb-2"
										v-for="(zone,i) in zones"
										:key="i"
								>
									<b-input-group class="input-groups">
										<b-button   block @click="editingDestinationZone = zone" class="zone-button" :variant="editingDestinationZone == zone ? 'warning' : 'primary' ">{{zone.name}}<md-icon v-if="editingDestinationZone == zone" style="float:right" icon="arrow_forward_ios"/></b-button>
									</b-input-group>
									<b-progress :max="averageZones['totalServices']"  height="1rem" v-if="editingOriginZone" >
										<b-progress-bar variant="success" :value="averageZonesTo['z-'+zone.id]" animated v-if="(averageZonesTo['z-'+zone.id] === averageZones['totalServices'])">
											<span><strong>{{averageZonesTo['z-'+zone.id]}} / {{averageZones['totalServices']}}</strong></span>
										</b-progress-bar>
										<b-progress-bar variant="danger" :value="averageZones['totalServices']" animated v-else-if="!(averageZonesTo['z-'+zone.id]>0)">
											<span><strong>0/{{averageZones['totalServices']}}</strong></span>
										</b-progress-bar>
										<b-progress-bar variant="info" :value="averageZonesTo['z-'+zone.id]" animated v-else>
											<span><strong>{{averageZonesTo['z-'+zone.id]}} / {{averageZones['totalServices']}}</strong></span>
										</b-progress-bar>
									</b-progress>
								</div>
							</b-card>
						</b-col>
						<b-col cols="4">
							<b-card>
								<template v-if="editingOriginZone && editingDestinationZone">
									<h3 class="text-center">Costos de viaje:</h3>
									<span >
									<p class="zoneLabel" style="text-align: left;">{{editingOriginZone.name}}</p>
									<p class="zoneLabel" style="text-align: center;"><md-icon icon="trending_flat airport_shuttle trending_flat" /></p>
									<p class="zoneLabel" style="text-align: right;">{{editingDestinationZone.name}}</p>
								</span>
									<hr>

									<div v-for="(priceData,index) in editingPrices" :key="index">
										<h5 class="text-center">[{{priceData.serviceType.id}}] {{priceData.serviceType.name}}</h5>
										<b-form-row>
											<b-col>
												<b-form-group label="One Way">
													<b-input-group>
														<b-input-group-prepend is-text>$</b-input-group-prepend>
														<b-form-input :disabled="!$hasPermission('prices.edit')" :readonly="heritance" v-model="priceData.oneway" type="number" step="0.01" required/>
														<b-input-group-append is-text>{{currency}}</b-input-group-append>
													</b-input-group>
												</b-form-group>
											</b-col>
											<b-col>
												<b-form-group label="Roundtrip">
													<b-input-group>
														<b-input-group-prepend is-text>$</b-input-group-prepend>
														<b-form-input :disabled="!$hasPermission('prices.edit')" :readonly="heritance" v-model="priceData.roundtrip" type="number" step="0.01" required  />
														<!-- <b-form-input v-model="priceData.roundtrip" type="number"  required  /> -->
														<b-input-group-append is-text>{{currency}}</b-input-group-append>
													</b-input-group>
												</b-form-group>
											</b-col>
										</b-form-row>
										<hr>
									</div>
									<p class="text-danger">**Prices at 0 means that the service is not allowed</p>
									<b-form-checkbox class="mb-2" v-model="applyPricesInverse">Apply costs to transportation on the opposite trip</b-form-checkbox>
									<b-overlay :show="loadingPrices" no-wrap ></b-overlay>
								</template>
							</b-card>
						</b-col>
						<b-col cols="2">
							<b-card>
								<span class="d-block" v-b-tooltip.bottom :title="heritance ? 'No es posible editar tarifas heredadas.' : ''">
								<b-button v-if="editingOriginZone && editingDestinationZone" :disabled="disabledBtnSave" type="submit" variant="success" size="lg" block><md-icon icon="save"/><br/>SAVE</b-button></span>
							</b-card>
						</b-col>
					</b-row>
				</b-form>
			</div>

		</div>
		<single-get-inherited-rates ref="singleGetInheritedRates"/>
	</div>
</template>

<script>
import MapZonesEditing from "./Map.vue";
import SingleGetInheritedRates from "./SingleGetInheritedRates";
import moment from "moment";
	export default {
		props: {
			ratePlanId: {
				type : Number,
				required: true,
			},
		},
		components: {MapZonesEditing,SingleGetInheritedRates},
		data(){
			return {
				averageZones:{totalPerZone:0,totalServices:0,zones:{}},
				averageZonesFrom :{},
				averageZonesTo :{},
				editingPrices:[],
				editingPricesBackup:[],
				// editingPricesSaved:true,
				zones:[],
				applyPricesInverse:true,
				loadingPrices:false,
				loading:true,
				heritance: false,
				editingOriginZone:null,
				editingDestinationZone:null,
				editingZoneNameIndex:-1,
				currencyOptions : [
					{value:'mxn',text:'MXN'},
					{value:'usd',text:'USD'}
				],
				ratePlanModel:{
					id:-1,
					name:"",
					supplierId:-1,
					salesChannelId:-1,
					zonedArea:null,
					supplierZonedArea:null,
					startDate:null,
					endDate:null

				},
				items:[],
			}
		},
		computed : {
			editingPricesSaved(){
				return JSON.stringify(this.editingPrices) === JSON.stringify(this.editingPricesBackup)
			},
			serviceTypesOpts(){
				return this.$root.auxVars.serviceTypesOpts.filter(st => st.value != 1)
			},
			disabledBtnSave(){
				if(!this.$hasPermission('prices.edit')){
					return true
				}
				return this.heritance
			},
			zonedAreaForPrice(){
				if(this.ratePlanModel.supplierId>0){
					return this.ratePlanModel.supplierZonedArea;
				}
				return this.ratePlanModel.zonedArea;
			},
			columnsDetailRatePlan(){
				let columns = [
					{ key: "id", label: "ID" },
					{ key: "name", label: "Nombre" },
					{ key: "currency", label: "Moneda" },
					{ key: "description", label: "Descripcion" },
					{ key: "zonedArea.name", label: "Area" },
					{ key: "percentageDiscount", label: "Descuento" },
				];
				if(this.ratePlanModel.supplierId>0){
					columns = [
						{ key: "id", label: "ID" },
						{ key: "name", label: "Nombre" },
						{ key: "supplier.name", label: "Proveedor" },
						{ key: "currency", label: "Moneda" },
						{ key: "description", label: "Descripcion" },
						{ key: "zonedArea.name", label: "Area Maestra" },
						{ key: "supplierZonedArea.name", label: "Proveedor Area" },
						{ key: "startDate", label: "F. Inicio" },
						{ key: "endDate", label: "F. Fin" },
						{ key: "percentageDiscount", label: "Descuento" },
					]

				}else if(this.ratePlanModel.salesChannelId>0){
					columns = [
						{ key: "id", label: "ID" },
						{ key: "name", label: "Nombre" },
						{ key: "salesChannel.name", label: "Canal de venta" },
						{ key: "currency", label: "Moneda" },
						{ key: "description", label: "Descripcion" },
						{ key: "zonedArea.name", label: "Area" },
						{ key: "startDate", label: "F. Inicio" },
						{ key: "endDate", label: "F. Fin" },
						{ key: "percentageDiscount", label: "Descuento" },
					]
				}

				if(this.ratePlanModel.parentRatePlanId>0){
					let addColumns = [
						{key:"heritanceModifierText",label:"Conf Herencia"}
					]
					columns.push(addColumns);
				}


				return columns;
			},
			columnsDetailRatePlanParent(){
				let columns = [
					{ key: "id", label: "ID" },
					{ key: "name", label: "Nombre" },
					{ key: "currency", label: "Moneda" },
					{ key: "description", label: "Descripcion" },
					{ key: "zonedArea.name", label: "Area" },
					{ key: "percentageDiscount", label: "Descuento" },
				];
				return columns;
			},
			canHaveChildren(){
				if(this.ratePlanModel.id== -1) return false;
				if(this.ratePlanModel.supplierId>0 || this.ratePlanModel.salesChannelId>0) return false;
				return true
			},
			endDate(){
				if(this.isEmpty(this.ratePlanModel.endDate)) return "Sin configurar"
				return this.formatDate(this.ratePlanModel.endDate)
			},

		},
		methods:{
			onSave(){
				this.loadingPrices = true
				let query = {
					prices: this.editingPrices.map(price => ({
						serviceTypeId:price.serviceType.id,
						oneway:price.oneway,
						roundtrip:price.roundtrip,
					})),
					applyPricesInverse:this.applyPricesInverse,
				}
				this.$root.api.put(`/rate-plans/prices/${this.ratePlanId}/${this.editingOriginZone.id}/${this.editingDestinationZone.id}`,query).then( () => {
					this.$root.showAlert('Actualización exitosa')
					this.loadPrevPrices()
					this.updateAverageConf()
				}).catch(this.$root.handleRequestError);
			},
			getRatePlan(){
				return this.$root.api.get(`/rate-plans/${this.ratePlanId}`)
			},
			fetchModel(){
				this.loading = true
				this.getRatePlan().then( res => {
					if((res.data.averageConfiguration?.totalPerZone?? 0) > 0) {
						this.averageZones = res.data['averageConfiguration'];
						this.initAverageFrom();
					}
					this.ratePlanModel = res.data;
					this.items = [this.ratePlanModel]
					this.currency = res.data.currency
					this.loading = false
					this.heritance 	   = res.data.parentRatePlanId !== null
					if(res.data.supplierId>0){
						this.zones = res.data.supplierZonedArea.zones
					}else{
						this.zones = res.data.zonedArea.zones
					}
				}).catch(this.$root.handleRequestError);
			},
			loadPrevPrices(){
				this.loadingPrices = true
				this.$root.api.get(`/rate-plans/prices/${this.ratePlanId}/${this.editingOriginZone.id}/${this.editingDestinationZone.id}`).then( res => {
					this.editingPrices = res.data
					this.editingPricesBackup = JSON.parse(JSON.stringify(this.editingPrices))
					this.loadingPrices = false
				}).catch(this.$root.handleRequestError);
			},
			initAverageFrom(){
				this.averageZonesFrom = {};
				let data = this.averageZones?? {};
				if('zones' in data){//creamos las variables
					for (let zonaFrom in data['zones']) {
						let total = 0;
						let actual = data['zones'][zonaFrom];
						for (let zonaTo in actual){
							total += actual[zonaTo]['qty'];
						}
						this.averageZonesFrom[zonaFrom] = total;
					}
				}
			},
			initAverageTo(){
				let total =0;
				this.averageZonesTo={};
				if(this.editingOriginZone.id>0){
					if('z-'+this.editingOriginZone.id in this.averageZones['zones']){
						let zonaFrom = this.averageZones['zones']['z-'+this.editingOriginZone.id];
						for (let index in zonaFrom) {
							total = zonaFrom[index]['qty'];
							this.averageZonesTo[index] = total;
						}
					}
				}
			},
			updateAverageConf(){
				this.getRatePlan().then((_res) =>{
					if(_res.data.averageConfiguration?.totalPerZone > 0){
						this.averageZones = _res.data['averageConfiguration'];
						this.initAverageFrom();
						this.initAverageTo()
					}
				});
			},
			drawZones(){
				if(this.editingOriginZone && this.editingDestinationZone){
					this.$refs['rp-map-zones'].setZonesByGeopoints([this.editingOriginZone,this.editingDestinationZone]);
				}
			},
			getSingleInheritedRates() {
				this.$refs["singleGetInheritedRates"].loadModel(this.ratePlanModel.id);
			},
			isEmpty(val){
				if(val == undefined || val == null || val == "") return true;
				return false;
			},
			formatDate(date) {
				if(this.isEmpty(date)) return date;
				return moment(date).format("DD/MM/YYYY");
			}
		},
		async mounted(){
			await this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesOpts','suppliersOpts']})
			this.fetchModel()
		},
		watch : {
			editingOriginZone(){
				if(this.editingOriginZone && this.editingDestinationZone) this.loadPrevPrices()
				this.initAverageTo()
				this.drawZones();
			},
			editingDestinationZone(){
				if(this.editingOriginZone && this.editingDestinationZone) this.loadPrevPrices()
				this.drawZones();
			},


		}
	}
</script>

<style scoped>
	.zoneLabel{
		line-height: 20px;
		font-size: 22px;
		margin-bottom: 0;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	input[type=number] {
		-moz-appearance: textfield;
	}
</style>
